










































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
class MeetingTypeItem extends Vue {
    [x: string]: any; // Allows access to your global websiteText method

    @Prop({ type: String, default: '' }) url!: string;
    @Prop({ type: String, required: true }) trackType!: string;
    @Prop({ type: String, required: true }) translationPrefix!: string;
    @Prop({ type: String, required: true }) retailerName!: string;
    /** Marks the new booking system so the meeting type gets a different check icon. */
    @Prop({ type: Boolean, default: false }) useNewMeetingBooking!: boolean;
    /** When provided, renders a button that emits 'select' instead of an anchor link. */
    @Prop({ type: String, default: '' }) selectType!: string;
    @Prop({ type: String, default: null }) backgroundImage!: string | null;
    @Prop({ type: String, default: null }) backgroundVideo!: string | null;

    handleSelect(): void {
        this.$emit('track-click', this.trackType);
        this.$emit('select', this.selectType);
    }
}

export default MeetingTypeItem;
